var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.step === 1)?_c('check-pw-component'):_c('div',[_c('member-update-component',{attrs:{"memberType":_vm.memberType}})],1)],1),_c('update-phone-modal'),_c('update-pw-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }